var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ErrorBoundary',[_c('ClientOnly',[(!_vm.loading)?_c('div',{staticClass:"little-academy"},[(_vm.isHaveFullLayout)?_c('div',[_c('academy-header'),_vm._v(" "),_c('div',{staticClass:"academy-screen"},[_c('academy-left-sidebar'),_vm._v(" "),_c('div',{class:[
              'academy-screen__content',
              {
                'justify-center': _vm.isCentered,
              },
            ]},[_c('div',{staticClass:"max-w-[1600px] xl:w-[944px] min-w-[944px]"},[_c('nuxt')],1)])],1)],1):_c('div',{staticClass:"w-screen h-screen"},[_c('nuxt')],1),_vm._v(" "),_c('portal-target',{attrs:{"multiple":"","name":"app-portal"}})],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }